import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Button, Divider, Form, Input, Message, Image, Item, Container, Search, Popup, Header, TextArea, Modal} from 'semantic-ui-react'
import smoothscroll from 'smoothscroll-polyfill'
import { Text, Translate, LanguageContext } from '../../helpers/language';

class Folder extends React.Component {

  constructor(){
    super()
    this.state = {
      errorAreaEditFolder: false,
      bookmarkTextEdit: '',
      modalOpen: false,
      popupOpen: false,
      name: ''
    }
  }

  handleOpenEditPopup = () => {
    this.setState({ popupOpen: true, bookmarkTextEdit: this.props.project.description, name: this.props.project.name})
  }

  handleCloseEditPopup = () => {
    this.setState({ popupOpen: false })
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })

    if (value !== '') {
      this.setState({errorAreaEditFolder: false})
    }
    else {
      this.setState({errorAreaEditFolder: true})
    }
  }

  closeModal = () => this.setState({modalOpen: false})

  openModal = () => this.setState({modalOpen: true})

  deleteFolder = () => {
    this.props.deleteFolder(this.props.project.project_id)
    this.setState({modalOpen: false })
  }

  updateFolder = () => {
    this.setState({ popupOpen: false })
    this.props.updateFolder(this.props.project.project_id, this.state.name, this.state.bookmarkTextEdit)
  }

  render() {
    const project = this.props.project
    const bookmarkTextEdit = this.state.bookmarkTextEdit
    const casoEdit = this.state.casoEdit
    const name = this.state.name
    const creationDate = (new Date(project.createdAt)).toLocaleDateString("it-IT")
    const updateDate = (new Date(project.updatedAt)).toLocaleDateString("it-IT")

    return (
      <Item>
        <Item.Content>
          <Link to={{pathname: '/projects/details', state: {id: project.project_id, name: project.name}}}>
            <Item.Header as='h4'>{project.name}</Item.Header>
          </Link>
          <Item.Description content={project.description} />
          <Item.Extra>
            <span><Text tid="folders_creation_date" />: {creationDate} - <Text tid="folders_last_edit_date" />: {updateDate}</span>
            <div style={{textAlign: 'right'}}>
              <Modal
                style={{maxWidth: '500px', minWidth: '320px'}}
                open={this.state.modalOpen}
                onClose={this.closeModal}
                onOpen={this.openModal}                
                trigger={<Button color='red'><Text tid="delete" /></Button>}
              >
                <Header content={Translate(this.context, 'folders_delete_title')} />
                <Modal.Content >
                  <h3><Text tid="folders_delete_message_prefix" /> {project.name} <Text tid="folders_delete_message_suffix" /></h3>
                </Modal.Content>
                <Modal.Actions>
                  <Button onClick={this.closeModal} negative>
                  <Text tid="no" />
                  </Button>
                  <Button
                    onClick={this.deleteFolder}
                    className='lisia-blue'
                    content={Translate(this.context, 'yes')}
                  />
                </Modal.Actions>
              </Modal>
              <Popup
                content={<div>
                          <Header as='h5'><Text tid="edit" /> {project.name}</Header>
                          <Form onSubmit={this.updateFolder}>
                            <Input fluid name='name' value={name} onChange={this.handleChange} placeholder={Translate(this.context, 'folders_name')} />
                            <TextArea name='bookmarkTextEdit' value={bookmarkTextEdit} onChange={this.handleChange} placeholder={Translate(this.context, 'folders_description')} />
                            <Button type='submit' style={{width: '100%'}} className='buttonsFolders lisia-blue' disabled={this.state.errorAreaEditFolder}><Text tid="save" /></Button>
                          </Form>
                        </div>}
                on='click'
                open={this.state.popupOpen}
                onOpen={this.handleOpenEditPopup}
                onClose={this.handleCloseEditPopup}
                trigger={<Button className='lisia-blue'><Text tid="edit" /></Button>}
              />
            </div>
          </Item.Extra>          
        </Item.Content>
      </Item>
    )
  }
}

Folder.propTypes = {
  project: PropTypes.object,
  deleteFolder: PropTypes.func,
  updateFolder: PropTypes.func
}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

Folder.contextType = LanguageContext;

export default connect(mapStateToProps)(Folder)